const resources = {
    title: 'Offres beauté',
    subtitle: 'Les nouvelles offres et promotions sont mises à jour chaque semaine. Soyez à l’affût!',
    terms: 'Offres en vigueur jusqu’à épuisement des stocks. Des modalités s’appliquent*.'
};

module.exports = function getResource(label) {
    return resources[label];
};
